<template>
  <Card title="微信公众号对接">
    <template slot="content">
      <div class="content">
        <div class="user-token">
          <p>对接地址:{{ userInfo.wechatName }}</p>
          <p>对接token: {{ userInfo.wechatPwd }}</p>
        </div>
        <div
          class="refresh"
          :class="loading ? 'loading' : ''"
          title="刷新token"
        >
          <i
            @click="getNewToken"
            class="iconfont icon-shuaxin icon-refresh"
          ></i>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from "@/components/common/Card";
import { refreshWebToken } from "@/api/user";
export default {
  components: {
    Card,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    userInfo: function () {
      return this.$store.getters.getUserInfo;
    },
  },
  methods: {
    getNewToken() {
      this.$utils.throttle(() => {
        this.loading = true;
        refreshWebToken().then(
          (res) => {
            this.loading = false;
            this.$tip.success("刷新成功!");
            this.$store.commit("upUserInfo", {
              wechatPwd: res.data,
            });
          },
          (err) => {
            this.loading = false;
            this.$tip.danger(err.msg);
          }
        );
      }, 5000);
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .user-token {
    word-break: break-all;
  }
  .refresh {
    text-align: center;
    width: 100%;
  }
  .icon-refresh {
    cursor: pointer;
    color: #5932ea;
    font-size: 2rem;
  }
  .loading {
    animation: scroll 1s linear infinite;
  }
}
@keyframes scroll {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
